import React from 'react';
import { FaFolderOpen, FaGithub } from 'react-icons/fa';
import './Projects.css';

function Projects() {
    return (
        <div className="projects-container">
            <div className="projects-header">
                <FaFolderOpen size={16} />
                <span>projects.json</span>
            </div>
            <div className="projects-content">
                <button className="projects-button" onClick={() => window.open('https://github.com/kirilo987', '_blank')}>
                    <FaGithub size={18} />
                    View all projects
                </button>
                <p>Check out all my personal projects on GitHub</p>
            </div>
        </div>
    );
}

export default Projects;